<template>
  <v-col cols="12">
    <v-row row grow wrap>
      <v-col lg6 class="filed">
        <v-row column>
          <v-col cols="12">
            <v-text-field
              ref="main"
              v-model="main_title"
              label="Основная статья"
              @click="setInput('main')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="main_title">
            <v-row row>
              <v-col cols="12">
                <v-card height="500px">
                  <v-img :src="banner.main_article.cover.url" :aspect-ratio="1.6"></v-img>
                  <v-card-title primary-title>{{ banner.main_article.title }}</v-card-title>
                  <v-subheader> {{ banner.main_article.date }}</v-subheader>
                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col lg6 class="filed">
        <v-row column>
          <v-col cols="12">
            <v-text-field
              ref="a1"
              v-model="article_1_title"
              label="1 сопутствующая статья"
              @click="setInput('a1')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="article_1_title">
            <v-row row>
              <v-col cols="12">
                <v-card height="500px">
                  <v-img :src="banner.article_1.cover.url" :aspect-ratio="1.6"></v-img>
                  <v-card-title primary-title>{{ banner.article_1.title }}</v-card-title>
                  <v-subheader> {{ banner.article_1.date }}</v-subheader>
                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg6 class="field">
        <v-row column>
          <v-col cols="12">
            <v-text-field
              ref="a2"
              v-model="article_2_title"
              label="2 сопутствующая статья"
              @click="setInput('a2')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="article_2_title">
            <v-row row>
              <v-col l126>
                <v-card>
                  <v-img :src="banner.article_2.cover.url" :aspect-ratio="1.6"></v-img>
                  <v-card-title primary-title>{{ banner.article_2.title }}</v-card-title>
                  <v-subheader> {{ banner.article_2.date }}</v-subheader>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg6 class="field">
        <v-row column>
          <v-col cols="12">
            <v-text-field
              ref="a2"
              v-model="article_3_title"
              label="2 сопутствующая статья"
              @click="setInput('a2')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="article_3_title">
            <v-row row>
              <v-col lg6>
                <v-card>
                  <v-img :src="banner.article_3.cover.url" :aspect-ratio="1.6"></v-img>
                  <v-card-title primary-title>{{ banner.article_3.title }}</v-card-title>
                  <v-subheader> {{ banner.article_3.date }}</v-subheader>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" scrollable max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <v-text-field v-model="q" label="Поиск" @input="search"></v-text-field>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <!--                    <v-radio-group v-model="dialogm1" column>-->
          <!--                        <v-radio :label="a.date" :value="a.title" v-for="a in searchResult" :key="a.id"></v-radio>-->
          <!--                    </v-radio-group>-->

          <v-list two-line>
            <v-list-tile
              :label="a.date"
              :value="a.title"
              v-for="a in searchResult"
              :key="a.id"
              @click="setChoice(a)"
            >
              <v-list-tile-avatar>
                <v-img :src="a.cover.sizes['50']"></v-img>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ a.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ a.date }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon ripple v-if="choice.id === a.id">
                  <v-icon color="green">check</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="dialog = false">Закрыть</v-btn>
          <v-btn color="blue darken-1" flat @click="setChoiceData">Выбрать</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
export default {
  name: 'banners_create_edit',
  data() {
    return {
      dialog: false,
      dialogm1: {},
      q: '',
      searchResult: [],
      article_1_title: '',
      article_2_title: '',
      article_3_title: '',
      main_title: '',
      banner: {
        main_article: {
          cover: { url: '' },
        },
        article_1: {
          cover: { url: '' },
        },
        article_2: {
          cover: { url: '' },
        },
        article_3: {
          cover: { url: '' },
        },
      },
      currentInput: '',
      choice: {},
    }
  },
  watch: {
    '$attrs.site_key': function () {
      this.updateData()
    },
    q: function () {
      this.search(this.q)
    },
  },
  mounted() {
    this.updateData()
  },
  update() {
    this.updateData()
  },
  methods: {
    resetDialog() {
      this.searchResult = []
      this.q = ''
      this.choice = {}
    },
    setChoiceData() {
      switch (this.currentInput) {
        case 'main':
          this.main_title = this.choice.title
          this.banner.main_article = { ...this.choice }
          break
        case 'a1':
          this.article_1_title = this.choice.title
          this.banner.article_1 = { ...this.choice }
          break
        case 'a2':
          this.article_2_title = this.choice.title
          this.banner.article_2 = { ...this.choice }
          break
        case 'a3':
          this.article_3_title = this.choice.title
          this.banner.article_3 = { ...this.choice }
          break
      }
      this.dialog = false
    },
    setChoice(a) {
      this.choice = a
    },
    setInput(key) {
      this.resetDialog()
      this.currentInput = key
      this.dialog = true
    },
    search(q) {
      this.axios({
        url: '/v1/articles',
        method: 'get',
        params: { title_contains: q },
      })
        .then((resp) => {
          this.$log.debug(resp.data)
          this.searchResult = resp.data || []
        })
        .catch((err) => {
          this.$log.error(err)
        })
    },
    updateData() {
      this.axios({
        url: `/v1/banners/${this.$attrs.site_key}`,
        method: 'get',
      })
        .then((resp) => {
          if (resp.status === 204) {
            this.banner = { ...this.defaultBanner }
          } else {
            this.banner = resp.data
          }
        })
        .catch((err) => {
          this.showSnackbar(err.toString())
        })
    },
  },
}
</script>

<style scoped lang="scss">
.field {
  padding: 10px;
}
</style>
